import CryptoJS from 'crypto-js';

const SECRET_KEY = 'ILOVEJNEC'; // replace this with an environment-safe key

export const encrypt = (text) => {
  return CryptoJS.AES.encrypt(text.toString(), SECRET_KEY).toString();
};

export const decrypt = (cipherText) => {
  const bytes = CryptoJS.AES.decrypt(cipherText, SECRET_KEY);
  return bytes.toString(CryptoJS.enc.Utf8);
};
